export default __webpack_public_path__ + "static/media/4.1Vid.50ed244b.mp4";